import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiURL } from "utils/Actions";
import api from "ApiClient";
import { SchoolReportType } from "utils/Types";
import { API_RESPONSE_STATUS } from "utils/Constants";
import { common } from "utils/Wording";
import { showErrorModal } from "utils/hooks/handleNotification";

export type SchoolReportSliceType = {
  loading: boolean;
  data: SchoolReportType;
};

const SchoolReportInit: SchoolReportSliceType = {
  loading: false,
  data: {} as SchoolReportType
};

export const fetchSchoolReportSettings = createAsyncThunk(ApiURL.reportSettings, async () => {
  try {
    const res = await api.get(ApiURL.reportSettings);
    if (res?.data?.status === API_RESPONSE_STATUS.ERROR) {
      throw new Error(common.loadingError);
    }
    return res?.data?.data ? res.data.data : [];
  } catch (error: any) {
    console.error(error);
    showErrorModal({
      title: common.failAsync,
      errors: error.response?.data?.errors ? error.response.data.errors : [error.message]
    });
    return SchoolReportInit.data;
  }
});

export const SchoolReportSlice = createSlice({
  name: "school-report-settings",
  initialState: SchoolReportInit,
  reducers: {
    updateSchoolReportSettings: (state, action) => {
      state.data.reportDays = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchSchoolReportSettings.pending, state => {
      return {
        ...state,
        loading: true
      };
    });
    builder.addCase(fetchSchoolReportSettings.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        data: {
          reportDays: action.payload
        }
      };
    });
    builder.addCase(fetchSchoolReportSettings.rejected, () => {
      return SchoolReportInit;
    });
  }
});

export const { updateSchoolReportSettings } = SchoolReportSlice.actions;

export default SchoolReportSlice.reducer;
